// extracted by mini-css-extract-plugin
export default {"container":"EM-z","topReviewHeading":"FM-z","criticalReview":"GM-z","favorableReview":"HM-z","vsSeparator":"IM-z"};